import { render, staticRenderFns } from "./GroupHistoryRecipients.vue?vue&type=template&id=37617423&scoped=true&"
import script from "./GroupHistoryRecipients.vue?vue&type=script&lang=ts&"
export * from "./GroupHistoryRecipients.vue?vue&type=script&lang=ts&"
import style0 from "./GroupHistoryRecipients.vue?vue&type=style&index=0&id=37617423&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37617423",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText,VCardTitle})
